/**
 * NOT USED
 */
export class Snapshot {

  public state: CdoSnapshotState;
  public type: SnapshotType;
  public author: string;
  public authorName: string;
  public authorEmail: string;
  public date: { date: { year: number, month: number, day: number }, time: { hour: number, minute: number, second: number, nano: number } } | string;

  constructor() {
  }
}

export class CdoSnapshotState {

  public properties: Map<string, any>;
}

export enum SnapshotType {
  INITIAL,
  UPDATE,
  TERMINAL
}
